import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildOperationalReadinessChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  extractAnalysisPeriod,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelOperationalReadiness = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Operational Readiness";
  const lines = stripTitleLines(cleanLines(markdown));
  const analysisPeriod = extractAnalysisPeriod(lines);
  const filteredLines = lines.filter((line) => !/^analysis period/i.test(line));
  const { table, before, after } = extractTableBlock(filteredLines);
  const chart = buildOperationalReadinessChart(table);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Operations & Data"
      sections={[
        {
          title: "Readiness Metrics",
          chart,
          chartTitle: "Readiness Radar",
          chartSubtitle:
            "This gives the report a strong executive snapshot of operational weak spots.",
          table,
          meta: analysisPeriod ? `Analysis Period: ${analysisPeriod}` : null,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelOperationalReadiness;
